import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { ethers } from 'ethers'

import { W3config as CONFIG } from './../../../../configs/config'
import abi from './../../../../configs/staking_ci.json'
import tokenAbi from './../../../../configs/token_ci.json'
import poolData from './../../../../configs/pools.json'
import axios from 'axios'

  const userData = JSON.parse(localStorage.getItem('userData'))

export const getPoolData = createAsyncThunk('getPoolData', async ({ provider }) => {
    // const provider = new ethers.providers.InfuraProvider('goerli', process.env.REACT_APP_INFURA_ID)
    const contract = new ethers.Contract(CONFIG.STAKING_CONTRACT_ADDRESS, abi, provider)
    const poolArr = poolData.map(async (item, i) => {
        const poolInfo = await contract.poolInfo(item.pid)
        const totalAlloc = await contract.totalAllocPoint()
        const apy = parseInt(poolInfo.allocPoint) / parseInt(totalAlloc) * 100
        const pool = { ...item, APR: apy }
        return pool
    })
    const returnVal = Promise.all(poolArr).then(values => values)

    return returnVal
})

export const getRewards = createAsyncThunk('getRewards', async (params) => {
    const { provider, pool, address } = params
    const contract = new ethers.Contract(CONFIG.STAKING_CONTRACT_ADDRESS, abi, provider)
    const reward = await contract.pendingToken(pool.pid, address)
    const rewardObj = { name: pool.name, reward: reward.toString() }

    return rewardObj
})

export const approve = createAsyncThunk('approveToken', async (params, { dispatch, getState }) => {
    const { signer, pool, modalId, setModalId } = params
    try {
        setModalId(3)
        const contract = new ethers.Contract(pool.tokenAddress, tokenAbi, signer)
        const address = await signer.getAddress()
        const balance = await contract.balanceOf(address)
        const tx = await contract.approve(CONFIG.STAKING_CONTRACT_ADDRESS, balance)
        await tx.wait()
        setModalId(null)
        await dispatch(getRewards({ signer, pool }))
        return { name: pool.name, approve: true }
        
    } catch (e) {
        setModalId(null)
        console.log(modalId)
        console.log(e)
        return { name: pool.name, approve: false }
    }
})


export const getStakeBalance = createAsyncThunk('getStakeBalance', async (params) => {
    const { provider, address } = params
    const contract = new ethers.Contract(CONFIG.STAKING_CONTRACT_ADDRESS, abi, provider)
    const stakeBalanceArr = poolData.map(async (item) => {
        const stake = await contract.userInfo(item.pid, address)
        const stakeObj = { name: item.name, balance: stake.amount.toString() }
        return stakeObj
    })

    const returnVal = Promise.all(stakeBalanceArr).then(values => values)
    return returnVal
})

export const harvest = createAsyncThunk('harvest', async (params, { dispatch, getState }) => {
    const { signer, pool } = params
    const contract = new ethers.Contract(CONFIG.STAKING_CONTRACT_ADDRESS, abi, signer)
    const amount = ethers.utils.parseUnits('0', 8)
    const estimateGas = await contract.estimateGas.withdraw(pool.pid, amount)
    const tx = {
        gasLimit: estimateGas.toString()
    }

    const harvestTx = await contract.withdraw(pool.pid, amount, tx)

    await dispatch(getPoolData({signer}))
    await dispatch(getRewards({ signer, pool }))
})

export const dbTransaction = createAsyncThunk('dbTransaction', async (params, { dispatch, getState }) => {
    const { provider, address, poolname, walletData, decimals } = params
      const userData = JSON.parse(localStorage.getItem('userData'))
    await dispatch(getPoolData({provider}))
    await dispatch(getStakeBalance({ provider, address }))
    const updatedState = getState().PoolData.stakeBalance
    console.log(updatedState)
    const poolBalance = updatedState[poolname]
    walletData.balance = ethers.utils.formatUnits(poolBalance, decimals)
    // entry data base
     try {
        const res = await axios.post(`${process.env.REACT_APP_HOST_URL}/api/wallets`, { data: walletData }, {
          headers: {
            Authorization: `Bearer ${userData.token}`
          }
        })

        return res.data.data
      } catch (e) {
        console.log(e)
      }

})
export const dbTransactionUpdate = createAsyncThunk('dbTransactionUpdate', async (params, { dispatch, getState }) => {
    const { provider, address, poolname, walletData, decimals, wallet_data_id } = params
     console.log("mjhe gussa arha ha xD")
      const userData = JSON.parse(localStorage.getItem('userData'))
      const id = wallet_data_id
    await dispatch(getPoolData({provider}))
    await dispatch(getStakeBalance({ provider, address }))
    const updatedState = getState().PoolData.stakeBalance
    console.log(updatedState)
    const poolBalance = updatedState[poolname]
    const wallet_balance = ethers.utils.formatUnits(poolBalance, decimals)
    console.log("mjhe gussa arha ha xD")
    // entry data base
     try {
        console.log("mjhe gussa arha ha xD")
        const response = await axios.put(`${process.env.REACT_APP_HOST_URL}/api/wallets/${id}`, {
            data: {
                balance: wallet_balance
            }
        }, {
            headers: {
                Authorization: `Bearer ${userData.token}`
            }
        })
        return response.data.data
      } catch (e) {
        console.log(e)
      }

})
// 
export const poolSlice = createSlice({ 
    name: "pools",
    initialState: {
        pools: [],
        approve: {
            USDC: false,
            USDT: false,
            WETH: false,
            WMATIC: false
        },
        stakeBalance: {
            USDC: 0,
            USDT: 0,
            WETH: 0,
            WMATIC: 0
        },
        rewards: {
            USDC: 0,
            USDT: 0,
            WETH: 0,
            WMATIC: 0
        }
    },
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(getPoolData.fulfilled, (state, action) => {
                state.pools = action.payload
            })
            .addCase(approve.fulfilled, (state, action) => {
                state.approve[action.payload.name] = action.payload.approve
            })
            .addCase(getStakeBalance.fulfilled, (state, action) => {
                action.payload.map(item => {
                    state.stakeBalance[item.name] = item.balance
                })

            })
            .addCase(getRewards.fulfilled, (state, action) => {
                state.rewards[action.payload.name] = action.payload.reward
            })
            .addCase(dbTransaction.fulfilled, (state, action) => {
                console.log(action)
            })
             .addCase(dbTransactionUpdate.fulfilled, (state, action) => {
                console.log(action)
            })
    }
})

export default poolSlice.reducer